"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSponsoredGuildCompetitionsResponseAllOfToJSON = exports.GetSponsoredGuildCompetitionsResponseAllOfFromJSONTyped = exports.GetSponsoredGuildCompetitionsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetSponsoredGuildCompetitionsResponseAllOfFromJSON(json) {
    return GetSponsoredGuildCompetitionsResponseAllOfFromJSONTyped(json, false);
}
exports.GetSponsoredGuildCompetitionsResponseAllOfFromJSON = GetSponsoredGuildCompetitionsResponseAllOfFromJSON;
function GetSponsoredGuildCompetitionsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sponsoredGuildCompetitions': (json['sponsoredGuildCompetitions'].map(_1.SponsoredGuildCompetitionFromJSON)),
    };
}
exports.GetSponsoredGuildCompetitionsResponseAllOfFromJSONTyped = GetSponsoredGuildCompetitionsResponseAllOfFromJSONTyped;
function GetSponsoredGuildCompetitionsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sponsoredGuildCompetitions': (value.sponsoredGuildCompetitions.map(_1.SponsoredGuildCompetitionToJSON)),
    };
}
exports.GetSponsoredGuildCompetitionsResponseAllOfToJSON = GetSponsoredGuildCompetitionsResponseAllOfToJSON;
